import React from 'react';

function TableRow({member, index}) {

	return (<div className={(index % 2 === 1 ? 'table-row-odd ' : '') + 'table-row flex w-100 items-center'}>
			<div className="athlete-column w-40 tl  pv3 ph3 flex items-center">
				<h2 className="ma0 ph2">{index + 1}.</h2>
				<img 
					alt={member.member_name + ' image'}
					className={'avatars br-100 h2 w2 ph2'} src={member.member_image_url} 
				/> 
				<div className="ph2">
					<h2 className="ma0">
						{member.member_name}
					</h2>
					<h5 className="mb0 mt2 f5">({member.points} pts this year)</h5>
				</div>

			</div>
			<div className="divider ">
			</div>
			<div className="movement-container w-60 pv3 flex justify-around items-center">
				<div className="movement">
					<strong>Points:</strong> {member.months['12'] ? member.months['12'].points : '-'}
				</div>
				{(member.months['12'] || {movements: []}).movements.map((movement, idx) => 
					<div className="movement" key={idx}>
						<strong>{movement.display_name}: </strong> {movement.total} (x{movement.multiplier})
					</div>
				)}
				{/*<div className="movement">
					<strong>Air Squats: </strong> 100 (x1)
				</div>*/}
			</div>
		</div>)
}

export default TableRow;